export default __webpack_public_path__ + "static/media/weather-pic-1.5124f5b2.jpg";